import {useEffect, useState} from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import dynamic  from "next/dynamic";
import Statistics from "../../components/components/Statistics";
import {getKeyWordsForEntityDetails} from '../api/cms/keywords/helper'
const KeyWordsData = dynamic(() => import("../../components/components/KeyWords/KeyWords"))
const NotFound = dynamic(() => import("../../components/components/NotFound"))
import White from '../../components/components/DetailsMedical/White'
import {getCookieCountry} from '../api/helpers/HeaderRequest'
import {getvocabTermsObj} from '../api/globals/terms/helpers'
import {isOnlyDigits} from '../../components/helpers/helpers'
import {getSlugFromCache} from '../api/cms/slug/helper'
import {getEntityDetailsFromCache} from '../api/registeration/profileReport/helper'
import {queryClient} from '../../react-query-config/queryClient'
import {dehydrate} from '@tanstack/react-query'
import {entityImagesFromCache} from '../api/registeration/entityImages/helper';
function Index({dehydratedState,entityWorkDays,slugResponse, pid, entityDetails, majors, address, blog, keyWords ,StatusIds,days,blogTypes,viewTypes,statisticEntities,htmlTexts}) {
  const [load,setLoad]=useState(true)
 useEffect(() => {

  }, [pid]);
  
  return (
    <div style={{height:"100%"}}>
     {entityDetails&&JSON.parse(entityDetails).length > 0 ? <><KeyWordsData keyWords={JSON.parse(keyWords)}/>
        <White
        dehydratedState={dehydratedState}
          entityId={pid[1]}
          pid={pid}
          entityDetails={entityDetails}
          majors={majors}
          address={address && JSON.parse(address)}
          blog={blog && JSON.parse(blog)}
          StatusIds={StatusIds}
          days={days}
          blogTypes={blogTypes}
          entityWorkDays={entityWorkDays}
        />

      {load&&<Statistics entityId={pid[1]} viewTypes={viewTypes} statisticEntities={statisticEntities} statisticsCode={"entity-details"}/>}
          </>
          :
     <NotFound number={slugResponse&&slugResponse.length>0?'404':'410'}/>
  }
    </div>
  )
}

export async function getServerSideProps({ params, locale, req,res }) {

  let appTerms=dehydrate(queryClient).queries.filter(ele=>ele.queryKey.includes("app-terms"))[0].state.data
  let statusQueryClient=dehydrate(queryClient).queries.filter(ele=>ele.queryKey.includes("statusIds"))[0].state.data
  const StatusIds =statusQueryClient
  let country = getCookieCountry(req) != null ?getCookieCountry(req).userCountry:null 
  let countries=appTerms.filter(i=>i.vocCode=="countries")
  let countriesService=countries.filter(i =>i.language.code==locale&& i.field2&&JSON.parse(i.field2)!=null &&JSON.parse(i.field2).service=="true")
  if(country==null&&countriesService.length>0){
    country=countriesService[0].code
  }
  let slugId = null;
  let SearchData = {
   
    userCountryCode:country,
  
  };
  let slugRes =null
  let slug = null;
  let id = null;


  if (params.id.length>1&&isOnlyDigits(params.id[1])) {
    id=params.id[1]
    SearchData.id=[id]
  }
  else if (typeof params.id=="object" && params.id.length == 1) {
    id = params.id[0];
    SearchData.id = [id];
  } else {
    slug = [params.id[1].replace(" ", "")];
    let slugData=  {
      url: JSON.stringify([params.id[1].replace(" ", "")]),
      slugEntityClassId: appTerms.filter(ele=>ele.vocCode=="slug-entity-classes")
        .filter((ele) => ele.code == "entity-details")
        .map((ele) => ele.id),
        cackeKeyType:"entity"
    }
    slugRes=await getSlugFromCache(slugData,req)
    if(slugRes&&slugRes.length > 0 ){
      id= slugRes[0].entityId
      SearchData.id = [id];
      slugId = slugRes.length > 0 ? slugRes[0].id : null;
    }
  }
  let response =null 
  let getMajors = null
  let getAddress=null

  let getBlog =null
  let  entityWorkDays=null
  if(SearchData.id){
    response = await getEntityDetailsFromCache({...SearchData,id:SearchData.id}, req);

    await queryClient.prefetchQuery({queryKey:["entityImages",SearchData.id],queryFn:async()=>await entityImagesFromCache({entityDetailsId:SearchData.id,entityImageType: ["logo"]},req)})
    await queryClient.prefetchQuery({queryKey:["view-types","statistic-entities"],queryFn:async()=>await getvocabTermsObj({"vocabCode": ["view-types","statistic-entities","days"]},req),staleTime:60*10*1000})
    await queryClient.prefetchQuery({queryKey:["days"],queryFn:async()=>await getvocabTermsObj({"vocabCode": ["days"]},req),staleTime:60*10*1000})
    // console.log("queryClient=========>",dehydrate(queryClient).queries)
    if(response&&response.length>0){
      getMajors=response[0].entityMajors
      getBlog= response[0].blogs
  
      getAddress= response[0].addressDetails
      entityWorkDays= response[0].entityWorkDays
      getBlog=getBlog.filter(ele=>ele.entityDetailsId==id&&ele.blogTypes[0].code=='about')
    }

 
  }
  let queryDataOfKeyWords = {};
  if (slugId!=null) {
    queryDataOfKeyWords.slugId = [slugId];
  }
  queryDataOfKeyWords.langCode = locale;
  if (response&&response.length > 0) {
    queryDataOfKeyWords.slugEntityClassType = [
      response[0].entityType[0].code,
    ];
  }
  queryDataOfKeyWords.slugEntityClass = ["entity-details"];
  queryDataOfKeyWords.entityId=id
  let getKeywords = await getKeyWordsForEntityDetails(queryDataOfKeyWords,req);
  if((slugRes!=null&&response==null)||(slugRes==null&&response==null)||(slugRes!=null&&response!=null&&response.length==0)){
    res.statusCode=410
  }
  return {
    props: {
      slugResponse:slugRes?JSON.stringify(slugRes):null,
      pid: [ response&&response.length > 0 &&response[0].entityType.length>0&& response[0].entityType[0].code,id],
      entityWorkDays:entityWorkDays&& entityWorkDays ? JSON.stringify(entityWorkDays) : null,
      majors:getMajors&& getMajors ? JSON.stringify(getMajors) : null,
      address: getAddress&&getAddress ? JSON.stringify([getAddress]) : null,
      slug: slug,
      keyWords: JSON.stringify(getKeywords),
      blog:getBlog&& getBlog ? JSON.stringify(getBlog) : null,
      entityDetails: response?JSON.stringify(response):null,
      StatusIds:[...new Set(StatusIds)],
      days: dehydrate(queryClient).queries.filter(ele=>ele.queryKey.includes("days"))[0].state.data.filter(ele=>ele.vocCode=="days"),
      blogTypes:appTerms.filter(ele=>ele.vocCode=="blog-types"),
      viewTypes:appTerms.filter(ele=>ele.vocCode=="view-types"),
      statisticEntities:appTerms.filter(ele=>ele.vocCode=="statistic-entities"),
      dehydratedState:dehydrate(queryClient),
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}

export default Index;
